// export const apiUrl = "http://localhost:3001";
export const apiUrl = "https://my-households-backend.herokuapp.com";